(() => {
 'use strict';
 if (window.__TOS293_FOCUS__) return;
 const config = {
  presets: {full:{scale:1,y:{500:.5,1000:.5}},label:{scale:1.8,y:{500:.553,1000:.588}},cap:{scale:2.5,y:{500:.198,1000:.198}}},
  threshold:9, panStep:48,
  copy:{whole:'Vezi sticla întreagă',up:'Explorează mai sus',down:'Explorează mai jos',
   intro:'Apropie un detaliu. Rotește în continuare. Descoperă sticla din orice unghi.',
   fullHint:'Trage lateral pentru rotire. + pentru apropiere.',
   detailHint:'Trage lateral pentru rotire, sus-jos pentru detalii.',
   view:'Sticla de aproape. Săgeți stânga-dreapta pentru rotire, sus-jos pentru deplasare, plus și minus pentru zoom.'},
  ...window.__TOS293_FOCUS_CONFIG__
 };
 let dialog,view,img,back,panButtons,retryFull,drag=null,lastZoom=1,scheduled=0;
 const pointers=new Set(),state={focus:'full',pan:0,zoom:1,base:1,y:0,min:0,max:0};
 const api=()=>window.__R290_MEDIA__;
 const icon=path=>'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+path+'</svg>';
 function camera(){
  scheduled=0;if(!dialog?.open||!api()?.active)return;
  const {format,zoom}=api().active,preset=config.presets[state.focus],h=img.offsetHeight||view.clientHeight;
  const s=preset.scale*zoom,center=preset.y[format],visible=view.clientHeight/(h*s);
  // Keep product material in the centre, even at the end of a vertical drag.
  const low=Math.min(.5,.09+visible*.2),high=Math.max(.5,.90-visible*.2);
  state.min=(center-high)*h*s;state.max=(center-low)*h*s;
  const detail=state.focus!=='full'||zoom>1;
  state.pan=detail?Math.max(state.min,Math.min(state.max,state.pan)):0;
  state.y=-(center-.5)*h*s+state.pan;state.zoom=zoom;state.base=preset.scale;
  view.style.setProperty('--r293-scale',String(s));view.style.setProperty('--r293-y',state.y.toFixed(3)+'px');
  dialog.dataset.focus=state.focus;dialog.dataset.detail=String(detail);
  back.hidden=!detail;panButtons.hidden=!detail;
  panButtons.querySelector('[data-pan="1"]').disabled=state.pan>=state.max-.5;
  panButtons.querySelector('[data-pan="-1"]').disabled=state.pan<=state.min+.5;
  dialog.querySelector('[data-hint]').textContent=detail?config.copy.detailHint:config.copy.fullHint;
 }
 function requestCamera(){scheduled ||= requestAnimationFrame(camera);}
 function resetZoom(){
  const active=api()?.active;if(!active)return;
  active.zoom=1;lastZoom=1;view.style.setProperty('--r290-zoom','1');
  dialog.querySelector('output').textContent='100%';
  dialog.querySelector('[data-zoom="-1"]').disabled=true;dialog.querySelector('[data-zoom="1"]').disabled=false;
 }
 function focus(kind){
  if(!api()?.active||!config.presets[kind])return;
  state.focus=kind;state.pan=0;resetZoom();view.classList.remove('r293-direct');
  if(img.hidden&&view.getAttribute('aria-busy')==='false')retryFull?.();
  dialog.querySelectorAll('.r290-mode').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.kind===kind)));
  // No setMode call: the same decoded frame, pending frame request and angle survive.
  camera();
 }
 function pan(amount){if(dialog?.dataset.detail!=='true')return;state.pan+=amount;camera();}
 function clearGesture(){drag=null;pointers.clear();view?.classList.remove('r293-direct');}
 function enhance(){
  const d=document.querySelector('.r292-dialog');if(!d||d.classList.contains('r293-dialog'))return;
  dialog=d;view=d.querySelector('.r290-view');img=view.querySelector('img');d.classList.add('r293-dialog');
  retryFull=d.querySelector('.r290-mode[data-kind="full"]').onclick;
  view.setAttribute('aria-label',config.copy.view);d.querySelector('.r290-options>p').textContent=config.copy.intro;
  d.querySelectorAll('.r290-mode').forEach(b=>{b.onclick=()=>focus(b.dataset.kind);});
  back=document.createElement('button');back.type='button';back.className='r293-whole';back.hidden=true;
  back.innerHTML=icon('<path d="M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5"/>');
  const label=document.createElement('span');label.textContent=config.copy.whole;back.append(label);
  back.onclick=()=>{focus('full');d.querySelector('.r290-mode[data-kind="full"]').focus({preventScroll:true});};view.append(back);
  api().bindTouchButtons(d);
  panButtons=document.createElement('div');panButtons.className='r293-pan';panButtons.hidden=true;
  for(const [direction,key,path]of [[1,'up','m6 14 6-6 6 6'],[-1,'down','m6 10 6 6 6-6']]){
   const b=document.createElement('button');b.type='button';b.dataset.pan=direction;b.setAttribute('aria-label',config.copy[key]);b.title=config.copy[key];b.innerHTML=icon('<path d="'+path+'"/>');b.onclick=()=>pan(direction*config.panStep);panButtons.append(b);
  }view.append(panButtons);
  view.addEventListener('pointerdown',e=>{
   if(e.target.closest('button')||e.button!==0)return;
   pointers.add(e.pointerId);
   if(pointers.size>1){drag=null;view.classList.add('r293-direct');return;}
   drag={id:e.pointerId,x:e.clientX,y:e.clientY,pan:state.pan,axis:null};
  },true);
  view.addEventListener('pointermove',e=>{
   if(!drag||e.pointerId!==drag.id||pointers.size!==1||api().dialog._record.pinching)return;
   const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
   if(!drag.axis&&Math.max(Math.abs(dx),Math.abs(dy))>=config.threshold)drag.axis=Math.abs(dx)>Math.abs(dy)*1.12?'rotate':'pan';
   if(drag.axis!=='pan'||dialog.dataset.detail!=='true')return;
   // Capture phase takes only vertical detail drags; native horizontal rotation and pinch are untouched.
   e.stopImmediatePropagation();view.classList.add('r293-direct');state.pan=drag.pan+dy;camera();
  },true);
  const release=e=>{pointers.delete(e.pointerId);drag=null;if(!pointers.size)view.classList.remove('r293-direct');};
  ['pointerup','pointercancel','lostpointercapture'].forEach(t=>view.addEventListener(t,release,true));
  view.addEventListener('keydown',e=>{
   if(e.target!==view||!['ArrowUp','ArrowDown'].includes(e.key)||dialog.dataset.detail!=='true')return;
   e.preventDefault();pan((e.key==='ArrowUp'?1:-1)*config.panStep);
  });
  // A double-click on an overlay control must not also toggle the underlying zoom.
  view.addEventListener('dblclick',e=>{if(e.target.closest('button'))e.stopImmediatePropagation();},true);
  new MutationObserver(()=>{const z=api()?.active?.zoom;if(z&&z!==lastZoom){lastZoom=z;requestCamera();}}).observe(view,{attributes:true,attributeFilter:['style']});
  new MutationObserver(()=>{if(d.open){clearGesture();focus('full');}}).observe(d,{attributes:true,attributeFilter:['open']});
  new ResizeObserver(requestCamera).observe(view);
  img.addEventListener('load',()=>{
   // A rotation can finish before the initial poster. Recover the visible,
   // current-format frame rather than leaving the superseded load in busy state.
   if(d.open&&api()?.active){
    const data=JSON.parse(document.getElementById('tos-media-290').textContent),f=api().active.format;
    if([data.paths[f].full,...data.frames[f]].some(src=>src&&new URL(src,location.href).href===img.src)){
     img.hidden=false;img.alt=d.querySelector('.r290-subtitle').textContent+' — '+(data.labels?.altFull||'sticla întreagă');view.setAttribute('aria-busy','false');
    }
   }requestCamera();
  });
  d.addEventListener('close',()=>{clearGesture();if(scheduled)cancelAnimationFrame(scheduled);scheduled=0;state.focus='full';state.pan=0;});
  focus('full');
 }
 new MutationObserver(enhance).observe(document.body,{childList:true});enhance();
 window.__TOS293_FOCUS__={config,state,focus,pan,get dialog(){return dialog;}};
})();
